<template lang="html">
  <div class="notice_alert">
    <!-- 查看详情 -->
    <div class="notice_details_con">
      <div class="notice_head">测试须知</div>
      <img class="close_btn" src="../../../assets/image/exam/close.png" alt="" @click="detailsClose">
      <div class="notice_details_html" v-html="details"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['details'],
  data(){
    return{
      showDetails: false,
    }
  },
  mounted(){

  },
  methods:{
    // 点击弹框关闭按钮
    detailsClose(){
      this.$parent.noticeShow(this.showDetails);
    },
  }
}
</script>

<style lang="css" scoped>
.notice_alert{
  height: 100%;
}
.notice_details_con{
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: url("../../../assets/image/exam/back.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 5rem 1rem 1rem 2rem;
  position: relative;
}
.notice_head{
  box-sizing: border-box;
  font-size: 1.8rem;
  color: #060606;
  width: 10.2rem;
  height: 3.2rem;
  position: absolute;
  left: 50%;
  margin-left: -5.1rem;
  background-color: #FEE84F;
  text-align: center;
  border: 0.2rem solid #000000;
  border-radius: 1.6rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: -5.5rem;
}
.close_btn{
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  width: 2.6rem;
}
.notice_details_html{
  height: 96%;
  box-sizing: border-box;
  padding-bottom: 2.5rem;
  overflow: auto;
}
</style>
